'use strict';

var _classCallCheck = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var map = require('async/map');

var debug = require('debug');

var once = require('once');

var log = debug('libp2p:swarm:dialer');

var DialQueue = require('./queue');
/**
 * Track dials per peer and limited them.
 */


var LimitDialer =
/*#__PURE__*/
function () {
  /**
   * Create a new dialer.
   *
   * @param {number} perPeerLimit
   * @param {number} dialTimeout
   */
  function LimitDialer(perPeerLimit, dialTimeout) {
    _classCallCheck(this, LimitDialer);

    log('create: %s peer limit, %s dial timeout', perPeerLimit, dialTimeout);
    this.perPeerLimit = perPeerLimit;
    this.dialTimeout = dialTimeout;
    this.queues = new Map();
  }
  /**
   * Dial a list of multiaddrs on the given transport.
   *
   * @param {PeerId} peer
   * @param {SwarmTransport} transport
   * @param {Array<Multiaddr>} addrs
   * @param {function(Error, Connection)} callback
   * @returns {void}
   */


  _createClass(LimitDialer, [{
    key: "dialMany",
    value: function dialMany(peer, transport, addrs, callback) {
      var _this = this;

      log('dialMany:start'); // we use a token to track if we want to cancel following dials

      var token = {
        cancel: false
      };
      callback = once(callback); // only call callback once

      map(addrs, function (m, cb) {
        _this.dialSingle(peer, transport, m, token, cb);
      }, function (err, results) {
        if (err) {
          return callback(err);
        }

        var success = results.filter(function (res) {
          return res.conn;
        });

        if (success.length > 0) {
          log('dialMany:success');
          return callback(null, success[0]);
        }

        log('dialMany:error');
        var error = new Error('Failed to dial any provided address');
        error.errors = results.filter(function (res) {
          return res.error;
        }).map(function (res) {
          return res.error;
        });
        return callback(error);
      });
    }
    /**
     * Dial a single multiaddr on the given transport.
     *
     * @param {PeerId} peer
     * @param {SwarmTransport} transport
     * @param {Multiaddr} addr
     * @param {CancelToken} token
     * @param {function(Error, Connection)} callback
     * @returns {void}
     */

  }, {
    key: "dialSingle",
    value: function dialSingle(peer, transport, addr, token, callback) {
      var ps = peer.toB58String();
      log('dialSingle: %s:%s', ps, addr.toString());
      var q;

      if (this.queues.has(ps)) {
        q = this.queues.get(ps);
      } else {
        q = new DialQueue(this.perPeerLimit, this.dialTimeout);
        this.queues.set(ps, q);
      }

      q.push(transport, addr, token, callback);
    }
  }]);

  return LimitDialer;
}();

module.exports = LimitDialer;